"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.putTelemarketingConsentsV1 = exports.putConsentsV1 = exports.getConsentsV1 = void 0;
/**
 * Return a list of the consents based on the given user with a state for the latest consent version
 * @param data The data for the request.
 * @param data.customerSegment Customer segment type
 * @param data.descriptionFormat The format used for the consent description. Default format is Markdown.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @returns GetConsentGroupResponse OK
 * @throws ApiError
 */
const getConsentsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/consent/consents/v1',
        query: {
            customer_segment: data.customerSegment,
            description_format: data.descriptionFormat,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getConsentsV1 = getConsentsV1;
/**
 * Update the status of customer's consents
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @param data.requestBody
 * @returns PutConsentsResponse OK
 * @throws ApiError
 */
const putConsentsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/consent/consents/v1',
        query: {
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putConsentsV1 = putConsentsV1;
/**
 * Update the status of customer's telemarketing consents
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @param data.requestBody
 * @returns PutConsentsResponse OK
 * @throws ApiError
 */
const putTelemarketingConsentsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/consent/consents/telemarketing/v1',
        query: {
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'DUPLICATED_CONSENT_TYPE',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putTelemarketingConsentsV1 = putTelemarketingConsentsV1;
